import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Select2 from 'v-select2-component'
import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller)
Vue.component('Select2', Select2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAZVmTOt9PmUdHQ1lYyCdWvKKM8OOJqavc',
    libraries: 'places',
  }
});


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
